import { AbsComponentFactory } from ".";
import { FormNode, PageNode, CellNode, RowNode, TableNode, DropdownGroupNode, DropdownElementNode, RadioButtonGroupNode, RadioButtonElementNode, SectionNode, LabelNode, CheckboxNode, TextBoxNode, DateNode, ElementNode, ImageNode, DynamoNode } from "dynamo-models";
import { NodeProps, PageWidget, ElementWidget, INodePropsInvar, withDrag } from "..";
import { ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, Card, CardContent, Grid, Divider, List, ListItem } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React from "react";
import { connect } from "react-redux";
import { MetaNode, IEditorState } from "../..";
import { ToolboxNode } from "../../supportNodes";

interface ICardProps extends INodePropsInvar {
    label: string;
}

interface ICardState {
    expanded: boolean;
}

interface IOuterCardListProps {
    children: any;
    containerNode: MetaNode;
}

class InnerCard extends React.Component<ICardProps,ICardState> {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        }
    }

    private onToggleOpen = () => this.setState(state => ({
        expanded: !state.expanded,
    }));

    public render() {
        return withDrag(this.props)(
            <ExpansionPanel onClick={this.onToggleOpen} expanded={this.state.expanded}>
                <ExpansionPanelSummary style={{background: "#f2f2f2"}}>
                    <Typography>
                        {this.props.label}
                    </Typography>
                </ExpansionPanelSummary>
            </ExpansionPanel>
        );
    }
}

class OuterCardList extends React.Component<IOuterCardListProps> {
    render () {
        return (
            <List>
            {
                this.props.children.map(v => (
                    <ListItem>
                    {
                        v
                    }
                    </ListItem>
                ))
            }
            </List>
        )
    }
}

const stateToProps = (state: IEditorState) => ({
    containerNode: state.container,
})

const OuterCardListWidget = connect(stateToProps)(OuterCardList);

class OuterCard extends React.Component<ICardProps, ICardState> {
    state = {
        expanded: false
    }

    onExpand = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    public render() {
        const children = (this.props.children !== undefined && this.props.children !== null ? this.props.children : []) as any[];

        return (
            <ExpansionPanel style={{width: "100%"}} onChange={this.onExpand} expanded={this.state.expanded}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>
                        {this.props.label}
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Grid container direction="column">
                        <Divider style={{marginBottom: 10}} />
                        <OuterCardListWidget children={children} />
                    </Grid> 
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

const InnerCardWidget = connect(stateToProps)(InnerCard)

export class ToolboxCardFactory extends AbsComponentFactory {
    public Prepare(node: FormNode) {
    }

    protected CreateFormComponent(children: [], nodeProps: NodeProps<FormNode>): JSX.Element {
        return <div></div>;
    }

    private getLabel = (nodeProps: NodeProps<DynamoNode>, defaultLabel: string): string => {
        let toolboxNode: ToolboxNode | undefined = nodeProps.node as ToolboxNode;
        let elementNode: ElementNode | undefined = nodeProps.node as ElementNode;

        if (toolboxNode && toolboxNode.label) {
            return toolboxNode.label;
        } else if (nodeProps.displayName) {
          return nodeProps.displayName;  
        } else if (elementNode && elementNode.dynamicName) {
            return elementNode.dynamicName;
        }

        return defaultLabel;
    }

    protected CreatePageComponent(children: [], nodeProps: NodeProps<PageNode>): JSX.Element {
        const textMaybe = nodeProps.node.text;
        const text = textMaybe !== undefined ? textMaybe : "Page";

        return (
            <OuterCard label={text} {...nodeProps} children={children} />
        );
    }

    protected CreateCellComponent(children: [], nodeProps: NodeProps<CellNode>): JSX.Element {
        return (
            <InnerCardWidget label={"Cell"} {...nodeProps} />
        )
    }

    protected CreateRowComponent(children: [], nodeProps: NodeProps<RowNode>): JSX.Element {
        return (
            <InnerCardWidget label={"Row"} {...nodeProps} />
        )
    }

    protected CreateTableComponent(children: [], nodeProps: NodeProps<TableNode>): JSX.Element {
        return (
            <InnerCardWidget label={"Table"} {...nodeProps} />
        )
    }

    protected CreateDropdownGroupComponent(children: [], nodeProps: NodeProps<DropdownGroupNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Dropdown List")} {...nodeProps} />
        )
    }

    protected CreateDropdownElementComponent(children: [], nodeProps: NodeProps<DropdownElementNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Dropdown Item")} {...nodeProps} />
        )
    }

    protected CreateRadioButtonGroupComponent(children: [], nodeProps: NodeProps<RadioButtonGroupNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Radio List")} {...nodeProps} />
        )
    }

    protected CreateRadioButtonElementComponent(children: [], nodeProps: NodeProps<RadioButtonElementNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Radio Item")} {...nodeProps} />
        )
    }

    protected CreateSectionComponent(children: [], nodeProps: NodeProps<SectionNode>): JSX.Element {
        return (
            <InnerCardWidget label={"Section"} {...nodeProps} />
        )
    }

    protected CreateLabelComponent(children: [], nodeProps: NodeProps<LabelNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Text")} {...nodeProps} />
        )
    }

    protected CreateCheckboxComponent(children: [], nodeProps: NodeProps<CheckboxNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Checkbox")} {...nodeProps} />
        )
    }

    protected CreateTextBoxComponent(children: [], nodeProps: NodeProps<TextBoxNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Text Field")} {...nodeProps} />
        )
    }

    protected CreateDateComponent(children: [], nodeProps: NodeProps<DateNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Date Field")} {...nodeProps} />
        )
    }

    protected CreateImageComponent(children: [], nodeProps: NodeProps<ImageNode>): JSX.Element {
        return (
            <InnerCardWidget label={this.getLabel(nodeProps, "Image")} {...nodeProps} />
        )
    }
}